import { render, staticRenderFns } from "./TrustPendingRecord.vue?vue&type=template&id=6d28e0c1&scoped=true"
import script from "./TrustPendingRecord.vue?vue&type=script&lang=js"
export * from "./TrustPendingRecord.vue?vue&type=script&lang=js"
import style0 from "./TrustPendingRecord.vue?vue&type=style&index=0&id=6d28e0c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28e0c1",
  null
  
)

export default component.exports